import { render, staticRenderFns } from "./detailConsumableList.vue?vue&type=template&id=63424ec4&"
import script from "./detailConsumableList.vue?vue&type=script&lang=js&"
export * from "./detailConsumableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports